import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { CardRequest } from '@models/card-requests/card-request.model';

import { QueryConfig } from '@app/shared/utils/query-config.utils';
import { PagedResponse } from '@models/commons/paged-response.model';
import { AppUtils } from '@app/shared/utils/app.utils';

import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CardRequestsService {
  static readonly API_CARDS_BASE_PATH = `${environment.api.rest.cards}`;

  constructor(private http: HttpClient) {
  }

  loadCardRequests(config: QueryConfig): Observable<PagedResponse<CardRequest>> {
    const params = AppUtils.buildPageableParams(config);
    return this.http.get<PagedResponse<CardRequest>>(`${CardRequestsService.API_CARDS_BASE_PATH}/requests`, {params});
  }

  loadCardRequest(id: number): Observable<CardRequest> {
    return this.http.get<CardRequest>(`${CardRequestsService.API_CARDS_BASE_PATH}/requests/${id}`);
  }

  createCardRequest(cardRequest: CardRequest): Observable<CardRequest> {
    return this.http.post<CardRequest>(`${CardRequestsService.API_CARDS_BASE_PATH}/requests`, cardRequest);
  }

  updateCardRequest(cardRequest: CardRequest): Observable<CardRequest> {
    return this.http.put<CardRequest>(`${CardRequestsService.API_CARDS_BASE_PATH}/requests/${cardRequest.requestId}`, cardRequest);
  }

  deleteCardRequest(id: number): Observable<number> {
    return this.http.delete<number>(`${CardRequestsService.API_CARDS_BASE_PATH}/requests/${id}`);
  }

  sendCardRequest(customerNo: string): Observable<any> {
    const params = new HttpParams().set('customerNo', customerNo);
    return this.http.post(`${CardRequestsService.API_CARDS_BASE_PATH}/new-request`, null, {params});
  }
}
